import { useEffect, useContext, useCallback } from 'react';

import { AuthContext } from 'context/auth-context';
import { CardContext } from 'context/cards/cardContext';
import { Cards, Overview } from 'lib/api';
import { SET_CARDS } from 'context/cards/types';
import { UPDATE_CARDS_METADATA } from 'context/cards/types';
import CreditModelV1Overview from './CreditModelV1Overview';
import CreditModelV2Overview from './CreditModelV2Overview';
import PrepaidModelOverview from './PrepaidModelOverview';
import { hasCreditModelV1, hasCreditModelV2, hasDepositModel, hasPINModel } from 'helpers/businesses';
import './OverviewStatistics.css';

const OverviewStatistics = () => {
    const { dispatch, shouldUpdateCardList } = useContext(CardContext);
    const { userInfo, businessInfo } = useContext(AuthContext);

    const fetchOverviewInfo = useCallback(async () => {
        try {
            const response = await Overview.getOverviewInfo();
            dispatch({
                type: UPDATE_CARDS_METADATA,
                payload: response
            });
        } catch (error) {
            console.error(error);
        }
    }, [dispatch]);
    useEffect(() => {
        if (userInfo.kyb === 'approved') {
            fetchOverviewInfo();
        }
    }, [fetchOverviewInfo, userInfo, shouldUpdateCardList]);

    const fetchCards = useCallback(async () => {
        try {
            const response = await Cards.getCards();
            dispatch({
                type: SET_CARDS,
                payload: response
            });
        } catch (error) {
            console.error(error);
        }
    }, [dispatch]);
    useEffect(() => {
        fetchCards();
    }, [fetchCards]);

    return (
        <>
            {hasCreditModelV1(businessInfo) && <CreditModelV1Overview />}
            {hasCreditModelV2(businessInfo) && <CreditModelV2Overview />}
            {(hasDepositModel(businessInfo) || hasPINModel(businessInfo)) && <PrepaidModelOverview />}
        </>
    );
};

export default OverviewStatistics;
